import { IconButton } from '@mui/material'
import ViewAgendaOutlinedIcon from '@mui/icons-material/ViewAgendaOutlined'
import { useOptionsPopover } from '@/core/popover/popover-hooks.tsx'
import { DefaultPopover } from '@/core/popover/DefaultPopover.tsx'
import { GroupByPopover } from '@/objects/collection-view/top-bar/GroupByPopover.tsx'
import { useCollectionViewContext } from '@/objects/collection-view/top-bar/CollectionViewPageContext.ts'
import { useTutorialTarget } from '@/tutorial/TutorialContext'

export function GroupByButton() {
  const { viewSettings } = useCollectionViewContext()
  const popover = useOptionsPopover()
  const tutorialTargetRef = useTutorialTarget('collection-groupby-button')

  return (
    <>
      <IconButton
        ref={tutorialTargetRef}
        disabled={!viewSettings}
        size="small"
        onClick={(e) => popover.openPopover(e.currentTarget)}
      >
        <ViewAgendaOutlinedIcon fontSize="medium" />
      </IconButton>
      <DefaultPopover anchorEl={popover.anchorEl} close={popover.closePopover}>
        <GroupByPopover />
      </DefaultPopover>
    </>
  )
}
